export const isSelectDocumentsBannerViewed = () =>
  localStorage.getItem('questionnaireSelectDocumentsBannerViewed') === 'true';

export const setSelectDocumentsBannerViewed = () => {
  localStorage.setItem('questionnaireSelectDocumentsBannerViewed', 'true');
};
